import React from 'react';
import { Chip } from '@mui/material';
import { Cancel, Check, HourglassEmpty } from '@mui/icons-material';
import { ExternalVoucherStatus, OrderData } from '../api';

// The order was settled on an unverifiable third-party code that an admin has not cleared yet
// (or has rejected). Callers use this to withhold anything that treats the booking as good.
export const isExternalVoucherUnapproved = (order?: OrderData) =>
  !!order?.external_voucher_redemption && order.external_voucher_redemption.status !== ExternalVoucherStatus.VERIFIED;

export const ALL_EXTERNAL_VOUCHER_STATUSES: ExternalVoucherStatus[] = [
  ExternalVoucherStatus.PENDING_VERIFICATION,
  ExternalVoucherStatus.VERIFIED,
  ExternalVoucherStatus.REJECTED,
];

// onClick makes the chip a shortcut into the reconciliation screen; callers that just display
// state (the reconciliation screen itself) omit it.
export const getExternalVoucherStatusChip = (
  status: ExternalVoucherStatus | undefined,
  translations: any,
  onClick?: () => void,
) => {
  const clickableProps = onClick ? { onClick, sx: { cursor: 'pointer' } } : {};
  switch (status) {
    case ExternalVoucherStatus.PENDING_VERIFICATION:
      return (
        <Chip
          size="small"
          color="warning"
          variant="outlined"
          icon={<HourglassEmpty />}
          {...clickableProps}
          label={translations('externalVouchers.status.pending_verification')}
        />
      );
    case ExternalVoucherStatus.VERIFIED:
      return (
        <Chip
          size="small"
          color="success"
          variant="outlined"
          icon={<Check />}
          {...clickableProps}
          label={translations('externalVouchers.status.verified')}
        />
      );
    case ExternalVoucherStatus.REJECTED:
      return (
        <Chip
          size="small"
          color="error"
          variant="outlined"
          icon={<Cancel />}
          {...clickableProps}
          label={translations('externalVouchers.status.rejected')}
        />
      );
    default:
      return null;
  }
};
